import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { MatSnackBar } from '@angular/material';
import { DataTableBodyCellComponent } from '@swimlane/ngx-datatable';
import { IfObservable } from 'rxjs/observable/IfObservable';


@Component({
	selector: 'SaldoIndemnizaciones',
	templateUrl: './SaldoIndemnizaciones.component.html'
})


export class SaldoIndemnizacionesComponent {

	public form: FormGroup;
	public formErrors: any;

	public ocultar: boolean= false;
	public mensaje: string="";


    
	public guardando: boolean = false;

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;
	

	public btnConsultar: boolean;


	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

            this.formErrors = {
                mes: {},
                nano: {}
            };

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
        this.snackBar.dismiss();
	}


    ngOnInit() {
        
    }

	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}
	openSnackBarEspecial(message: string, action: string) {
        let snackBarRef =  this.snackBar.open(message, action);
 
        snackBarRef.onAction().subscribe(() => {
           
            this.ocultar = false;
            this.mensaje = "";
        });
        
        let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;        
        
        if (shand.length != 0) {
                for (let i=0;i<shand.length;i++){
                shand[i].style.backgroundColor = "rgb(255 204 214)";
                }
            }
    }


    
    
    generarReporte(){

        let parametros = {
                           VREPORTE : 'Total_y_saldo_de_Indemnizados',
                           VPARAMETRO: ''
                        };
        
        this._serviciosGenerales.get('procedure/GENERAR_REPORTE_EXCEL', parametros).subscribe(
            result => {
                console.log(result);

                if (result.error == true || result.mensaje.toUpperCase().indexOf('OK') == -1) {
                    this.openSnackBar(result.mensaje, "X");
                    this.guardando = false;
                    return;
                } else {
                    this.openSnackBar('Reporte generado correctamente, en pocos minutos llegara el archivo al correo: '+result.mensaje.replace('OK',''), "X");
                }
                this.guardando = false;
            }, error => {
                var errorMensaje = <any>error;
                console.log('Error al enviar la peticion ', errorMensaje);
                this.openSnackBarEspecial("No se logró obtener la respuesta del servidor, por favor verificar si se efectuó este proceso.", "X");
                this.guardando = false;
            })
    }
    
}





// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Saldo Indemnizaciones/SaldoIndemnizaciones.component.ts